
export const countryCodeArray = [
  ['AF', 'Afghanistan'],
    
  ['AX', 'Aland Islands'],

  ['AL', 'Albania'],

  ['DZ', 'Algeria'],

  ['AS', 'American Samoa'],

  ['AD', 'Andorra'],

  ['AO', 'Angola'],

  ['AI', 'Anguilla'],

  ['AQ', 'Antartica'],

  ['AG', 'Antigua'],

  ['AR', 'Argentina'],

  ['AM', 'Armenia'],

  ['AW', 'Aruba'],

  ['AU', 'Australia'],

  ['AT', 'Austria'],

  ['AZ', 'Azerbaijan'],

  ['BS', 'Bahamas'],

  ['BH', 'Bahrain'],

  ['BD', 'Bangladesh'],

  ['BB', 'Barbados'],

  ['BY', 'Belarus'],

  ['BE', 'Belgium'],

  ['BZ', 'Belize'],

  ['BJ', 'Benin'],

  ['BM', 'Bermuda'],

  ['BT', 'Bhutan'],

  ['BO', 'Bolivia'],

  ['BQBON', 'Bonaire'],

  ['BA', 'Bosnia-Herzegovina'],

  ['BW', 'Botswana'],

  ['BV', 'Bouvet Island'],

  ['BR', 'Brazil'],

  ['IO', 'British Indian Ocean Territory'],

  ['VG', 'British Virgin Islands'],

  ['BN', 'Brunei'],

  ['BG', 'Bulgaria'],

  ['BF', 'Burkina Faso'],

  ['BI', 'Burundi'],

  ['KH', 'Cambodia'],

  ['CM', 'Cameroon'],

  ['CA', 'Canada'],

  ['CV', 'Cape Verde'],

  ['BQ', 'Caribbean Netherlands'],

  ['KY', 'Cayman Islands'],

  ['CF', 'Central African Republic'],

  ['TD', 'Chad'],

  ['CL', 'Chile'],

  ['CN', 'China'],

  ['CX', 'Christmas Island'],

  ['CC', 'Cocos (Keeling) Islands'],

  ['CO', 'Colombia'],

  ['KM', 'Comoros'],

  ['CG', 'Congo'],

  ['CD', 'Congo, Democratic Republic of'],

  ['CK', 'Cook Islands'],

  ['CR', 'Costa Rica'],

  ['HR', 'Croatia'],

  ['CU', 'Cuba'],

  ['CW', 'Curacao'],

  ['CY', 'Cyprus'],

  ['CZ', 'Czech Republic'],

  ['DK', 'Denmark'],

  ['DJ', 'Djibouti'],

  ['DM', 'Dominica'],

  ['DO', 'Dominican Republic'],

  ['TL', 'East Timor'],

  ['EC', 'Ecuador'],

  ['EG', 'Egypt'],

  ['SV', 'El Salvador'],

  ['GQ', 'Equatorial Guinea'],

  ['ER', 'ERITREA'],

  ['EE', 'ESTONIA'],

  ['ET', 'Ethiopia'],

  ['EB', 'European Union w/o dg'],

  ['FK', 'Falkland Islands'],

  ['FO', 'Faroe Islands'],

  ['FJ', 'Fiji'],

  ['FI', 'Finland'],

  ['FR', 'France'],

  ['GF', 'French Guiana'],

  ['PF', 'French Polynesia'],

  ['TF', 'French Southern Territories'],

  ['GA', 'Gabon'],

  ['GM', 'Gambia'],

  ['GZ', 'Gaza Strip'],

  ['GE', 'Georgia'],

  ['DE', 'Germany'],

  ['GH', 'Ghana'],

  ['GI', 'Gibraltar'],

  ['GB', 'Great Britain(United Kingdom)'],

  ['VGGRTH', 'Great Thatch Islands'],

  ['VGGRTO', 'Great Tobago Islands'],

  ['GR', 'Greece'],

  ['GL', 'Greenland'],

  ['GD', 'Grenada'],

  ['GP', 'Guadeloupe'],

  ['GU', 'Guam'],

  ['GT', 'Guatemala'],

  ['GN', 'Guinea'],

  ['GW', 'Guinea Bissau'],

  ['GY', 'Guyana'],

  ['HT', 'Haiti'],

  ['HM', 'Heard and McDonald Islands'],

  ['HN', 'Honduras'],

  ['HK', 'HONG KONG SAR, CHINA'],

  ['HU', 'Hungary'],

  ['IS', 'Iceland'],

  ['IN', 'India'],

  ['ID', 'Indonesia'],

  ['IR', 'Iran'],

  ['IQ', 'Iraq'],

  ['IE', 'Ireland'],

  ['IL', 'Israel'],

  ['IT', 'Italy'],

  ['CI', 'Ivory Coast'],

  ['JM', 'Jamaica'],

  ['JP', 'Japan'],

  ['JO', 'Jordan'],

  ['VGJVDI', 'Jost Van Dyke Islands'],

  ['KZ', 'Kazakhstan'],

  ['KE', 'Kenya'],

  ['KI', 'Kiribati'],

  ['KV', 'Kosovo'],

  ['KW', 'Kuwait'],

  ['KG', 'Kyrgyzstan'],

  ['LA', 'Laos'],

  ['LV', 'LATVIA'],

  ['LB', 'Lebanon'],

  ['LS', 'Lesotho'],

  ['LR', 'Liberia'],

  ['LY', 'LIBYA'],

  ['LI', 'Liechtenstein'],

  ['LT', 'LITHUANIA'],

  ['LU', 'Luxembourg'],

  ['MO', 'MACAU SAR, CHINA'],

  ['MG', 'Madagascar'],

  ['MW', 'Malawi'],

  ['MY', 'Malaysia'],

  ['MV', 'Maldives'],

  ['ML', 'Mali'],

  ['MT', 'Malta'],

  ['MH', 'Marshall Islands'],

  ['MQ', 'Martinique'],

  ['MR', 'Mauritania'],

  ['MU', 'Mauritius'],

  ['YT', 'Mayotte'],

  ['MX', 'Mexico'],

  ['FM', 'Micronesia'],

  ['MD', 'Moldova'],

  ['MC', 'Monaco'],

  ['MN', 'Mongolia'],

  ['ME', 'Montenegro'],

  ['MS', 'Montserrat'],

  ['MA', 'Morocco'],

  ['MZ', 'Mozambique'],

  ['MM', 'Myanmar / Burma'],

  ['NA', 'Namibia'],

  ['NR', 'Nauru'],

  ['NP', 'Nepal'],

  ['NL', 'Netherlands'],

  ['NC', 'New Caledonia'],

  ['NZ', 'New Zealand'],

  ['NI', 'Nicaragua'],

  ['NE', 'Niger'],

  ['NG', 'Nigeria'],

  ['NU', 'Niue'],

  ['NF', 'Norfolk Island'],

  ['VGNOIS', 'Norman Island'],

  ['KP', 'North Korea'],

  ['MP', 'Northern Mariana Islands'],

  ['NO', 'Norway'],

  ['OM', 'Oman'],

  ['PK', 'Pakistan'],

  ['PW', 'Palau'],

  ['PS', 'Palestine'],

  ['PA', 'Panama'],

  ['PG', 'Papua New Guinea'],

  ['PY', 'Paraguay'],

  ['PE', 'Peru'],

  ['PH', 'Philippines'],

  ['PN', 'Pitcairn'],

  ['PL', 'Poland'],

  ['PT', 'Portugal'],

  ['PR', 'Puerto Rico'],

  ['QA', 'Qatar'],

  ['MK', 'REPUBLIC OF NORTH MACEDONIA '],

  ['RE', 'Reunion'],

  ['RO', 'Romania'],

  ['MPROT', 'Rota '],

  ['RU', 'Russia'],

  ['RW', 'Rwanda'],

  ['BQSAB', 'Saba'],

  ['KN', 'Saint Kitts and Nevis'],

  ['MF', 'Saint Martin'],

  ['MPSAI', 'Saipan'],

  ['WS', 'Samoa'],

  ['SM', 'San Marino'],

  ['ST', 'Sao Tome and Principe'],

  ['SA', 'Saudi Arabia'],

  ['SN', 'Senegal'],

  ['RS', 'Serbia'],

  ['SC', 'Seychelles'],

  ['SL', 'Sierra Leone'],

  ['SG', 'Singapore'],

  ['BQSEUS', 'Sint Eustatius'],

  ['SX', 'Sint Maarten'],

  ['SK', 'Slovak Republic'],

  ['SI', 'Slovenia'],

  ['SB', 'Solomon Islands'],

  ['SO', 'Somalia'],

  ['ZA', 'South Africa'],

  ['GS', 'South Georgia &amp; So Sandwich Is'],

  ['KR', 'South Korea'],

  ['ES', 'Spain'],

  ['LK', 'Sri Lanka'],

  ['VISTCR', 'St. Croix Island'],

  ['SH', 'St. Helena'],

  ['VISTJO', 'St. John'],

  ['LC', 'St. Lucia'],

  ['PM', 'St. Pierre'],

  ['VISTTH', 'St. Thomas'],

  ['VC', 'St. Vincent'],

  ['SD', 'Sudan'],

  ['SR', 'Suriname'],

  ['SJ', 'Svalbard and Jan Mayen Island'],

  ['SZ', 'Swaziland'],

  ['SE', 'Sweden'],

  ['CH', 'Switzerland'],

  ['SY', 'Syria'],

  ['TW', 'TAIWAN, CHINA'],

  ['TJ', 'Tajikistan'],

  ['TZ', 'Tanzania'],

  ['TH', 'Thailand'],

  ['MPTIN', 'Tinian'],

  ['TG', 'Togo'],

  ['TK', 'Tokelau'],

  ['TO', 'Tonga'],

  ['VGTOIS', 'Tortola Island'],

  ['TT', 'Trinidad and Tobago'],

  ['TN', 'Tunisia'],

  ['TR', 'Turkey'],

  ['TM', 'Turkmenistan'],

  ['TC', 'Turks And Caicos Islands'],

  ['TV', 'Tuvalu'],

  ['UM', 'U S Minor Outlying Islands'],

  ['VI', 'U S Virgin Islands'],

  ['UG', 'Uganda'],

  ['UA', 'Ukraine'],

  ['AE', 'United Arab Emirates'],

  ['US', 'United States'],

  ['UY', 'Uruguay'],

  ['UZ', 'Uzbekistan'],

  ['VU', 'Vanuatu'],

  ['VA', 'Vatican City'],

  ['VE', 'Venezuela'],

  ['VN', 'Vietnam'],

  ['WF', 'Wallis and Futuna Islands'],

  ['WE', 'West Bank'],

  ['EH', 'Western Sahara'],

  ['YE', 'Yemen'],

  ['ZM', 'Zambia'],

  ['ZW', 'Zimbabwe']

]



// WEBPACK FOOTER //
// ./src/store/shared/countryCode.js